import { render, staticRenderFns } from "./CategorySupplyInactive.vue?vue&type=template&id=58a2e0d0&scoped=true"
import script from "./CategorySupplyInactive.vue?vue&type=script&lang=js"
export * from "./CategorySupplyInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2e0d0",
  null
  
)

export default component.exports